<template>
    <div itemprop="itemListElement" itemscope itemtype="http://schema.org/Accommodation"
		:class="card_class">
        <meta itemprop="name" :content="ad.title">
        <meta itemprop="position" :content="index">
        <meta itemprop="url" :content="ad.url">
        <meta itemprop="image" :content="ad.main_photo">
        <meta itemprop="address" :content="ad.location">
        <div class="property-card">
            <a :href="ad.url" target="_blank" @click="openAdPage(ad, $event)">
                <div class="glide" :class="'carousel' + ad.id">
                    <div class="glide__track" data-glide-el="track">
                        <div class="glide__slides flex overflow-hidden">
                            <img v-bind:key="index" v-for="(photo, index) in ad.photos" :src="photo.url" alt="Imagem do imóvel" loading="lazy" fetchpriority="high" class="glide__slides object-cover w-auto">
                        </div>
                    </div>
                    <div class="glide__arrows" data-glide-el="controls">
                        <button class="glide__arrow glide__arrow--left" data-glide-dir="<"><i class="fas fa-chevron-left"></i></button>
                        <button class="glide__arrow glide__arrow--right" data-glide-dir=">"><i class="fas fa-chevron-right"></i></button>
                    </div>
                    <div class="glide__bullets" data-glide-el="controls[nav]">
                        <button v-bind:key="ind" v-for="(photo, ind) in ad.photos" class="glide__bullet" :data-glide-dir="'=' + ind"></button>
                    </div>
                    <span v-if="ad.promotion_tag" class="promotion-tag" :class="ad.promotion_tag.color">
                        <i :class="ad.promotion_tag.icon"></i>{{ ad.promotion_tag.name }}
                    </span>
                    <favorite-button :fk_property="ad.id" :is_favorite="ad.is_favorite" inline-template>
                        <div>
                            <a @click.prevent="setFavorite()" href="#" class="property-favorite waves-effect waves-light">
                                <i class="fa-heart fa-2x text-danger" v-bind:class="icon"></i>
                            </a>
                        </div>
                    </favorite-button>
                </div>

                <div class="property-content">
                    <div class="listingInfo">
                        <div class="price_row">
                            <h5 class="text-success m-t-0">{{ ad.rent_price }} por mês</h5>
                        </div>
                        <div class="">
                            <h3 class="text-overflow text-dark">{{ truncate(ad.title, 40) }}</h3>
                            <p class="text-muted text-overflow"><i class="fas fa-map-marker-alt m-r-5"></i>{{ ad.location }}</p>

                            <div class="row">
                                <div class="col-xs-12">
                                    <p class="description font-13 text-muted m-b-0">{{ truncate(ad.description, 150) }}</p>
                                </div>
                            </div>

                            <div class="row m-t-20">
                                <div class="col-xs-12 property-action">
                                    <span v-if="ad.gender == 'M'" class="icons" data-toggle="tooltip" data-placement="top" title="Apenas para homens">
                                        <i class="fas fa-male"></i>
                                        <span>Para homens</span>
                                    </span>
                                    <span v-if="ad.gender == 'F'" class="icons" data-toggle="tooltip" data-placement="top" title="Apenas para mulheres">
                                        <i class="fas fa-female"></i>
                                        <span>Para mulheres</span>
                                    </span>
                                    <span v-if="ad.gender == 'MF' || ad.gender == null" class="icons" data-toggle="tooltip" data-placement="top" title="Disponível para homens e mulheres">
                                        <i class="fas fa-restroom"></i>
                                        <span>Qualquer sexo</span>
                                    </span>
                                    <span class="icons pull" data-toggle="tooltip" data-placement="top" title="Número de quartos no imóvel"><i class="fas fa-bed m-r-10"></i><span>{{ ad.bedrooms }}</span></span>
                                    <span class="icons" data-toggle="tooltip" data-placement="top" title="Número de banheiros no imóvel"><i class="fa fa-bath m-r-10"></i><span>{{ ad.bathrooms }}</span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
import Glide, { Controls, Swipe } from '../../../../../legacy/node_modules/@glidejs/glide/dist/glide.modular.esm';
import FavoriteButton from './../../components/ad/favorite-button/favorite-button.vue';

export default {
    props: {
        ad: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        }
    },
    components: {
        FavoriteButton
    },
    computed: {
        view() {
            return this.$store.getters.getView;
        },
        card_class() {
            return this.view === 'list' ? 'col-lg-3 col-md-4 col-sm-6 col-xs-12' : 'col-lg-4 col-md-6 col-sm-12 col-xs-12';
        }
    },
    methods: {
        openAdPage(property_ad, ev) {
            const class_list = ev.target.classList;

            if (class_list.contains('glide__arrow') ||
                class_list.contains('glide__bullet') ||
                class_list.contains('fa-chevron-right') ||
                class_list.contains('fa-chevron-left')) {
                    ev.preventDefault();
                    return;
            }

            this.registerVisit(property_ad.id, this.index);

            window.dataLayer.push({
                'event': 'ad_click',
                'event_category': 'search_page',
                'event_label': 'index-' + this.index,
                'id': property_ad.id,
                'location': property_ad.location,
                'rent_price': property_ad.rent_price
            });
        },
        registerVisit(property_id) {
            axios.post('/property/record-visit/' + property_id, {
                index: this.index,
            });
        },
        truncate: function(string, value) {
            if (string.length > value) {
                return string.substring(0 , value) + '...';
            }

            return string;
        }
    },
    mounted() {
        new Glide('.carousel' + this.ad.id,
            {
                'animationDuration': 800,
                'rewind': false,
                'gap': 0
            })
                .mount({ Controls, Swipe })
                .on('run', () => {
                    window.dataLayer.push({
                        event: 'change-photo-gallery',
                        event_category: 'search_page',
                        event_label: 'ad-' + this.index,
                    });
                });
        $('[data-toggle="tooltip"]').tooltip({ container: 'body' });
    }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/components/property_card";
    .glide:not(:hover) {
        .glide__arrows {
            opacity: 0;
        }
    }

    .glide__arrow--disabled {
        opacity: 0;
    }

    .glide__arrow {
        background-color: #FFF;
        color: #555;
        border-radius: 50%;
    }

    .glide__slides {
        height: 230px;
    }

    .object-cover {
        object-fit: cover;
    }

    .w-auto {
        width: auto;
    }

    .flex {
        display: flex;
    }

    .overflow-hidden {
        overflow: hidden;
    }

    .property-card {
        cursor: pointer;
    }

    .promotion-tag {
        padding: 5px 7px;
        border-radius: 3px;
        top: 10px;
        left: 10px;
        position: absolute;

        i {
            margin-right: 5px;
        }

        &.danger {
            background-color: #f5707a;
            color: #FFF;
        }

        &.default {
            background-color: #FFF;
            color: #505458;
        }
    }
</style>
